module.exports = "/assets/hospital_postcode-2f8249aed9f936b21b033f25ca4ebaf1.svg";